<!-- <template>
  <span class="countdown-timer">
    <h2 :class="{ flash: isFlashing, highlight: isHighlighted }">TIME: {{ formattedTime }}</h2>
  </span>
</template> -->

<template>
  <span class="countdown-timer">
    <!-- <span class="time-label">TIME:</span> -->
    <span class="time-value" ref="timerText">{{ formattedTime }}</span>
  </span>
</template>





<script>
import gsap from "gsap";

export default {
  props: {
    initialMinutes: {
      type: Number,
      default: 0,
    },
    initialSeconds: {
      type: Number,
      default: 30,
    },
  },
  data() {
    return {
      minutes: this.initialMinutes,
      seconds: this.initialSeconds,
      timer: null,
      startTime: null,
      totalDuration: 0, // Total duration in seconds
    };
  },
  computed: {
    formattedTime() {
      const paddedMinutes = String(this.minutes).padStart(2, "0");
      const paddedSeconds = String(this.seconds).padStart(2, "0");
      return `${paddedMinutes}:${paddedSeconds}`;
    },
    remainingTime() {
      return this.minutes * 60 + this.seconds;
    },
  },
  methods: {
    startTimer() {
      if (this.timer) return; // If the timer is already running, do nothing

      if (this.startTime) {
        // Resume the timer if it was paused
        this.startTime = Date.now() - (this.totalDuration - this.remainingTime) * 1000; // Adjust start time
      } else {
        // Start the timer for the first time
        this.startTime = Date.now();
        this.totalDuration = this.initialMinutes * 60 + this.initialSeconds;
      }

      this.timer = setInterval(() => {
        this.updateTimer();
      }, 100); // Check more frequently for better accuracy
    },

    pauseTimer() {
      clearInterval(this.timer); // Stop the interval
      this.timer = null; // Set timer to null to indicate it's paused
    },

    updateTimer() {
      if (!this.startTime) return;

      const elapsed = Math.floor((Date.now() - this.startTime) / 1000);
      const remaining = Math.max(0, this.totalDuration - elapsed);

      if (remaining <= 0) {
        this.minutes = 0;
        this.seconds = 0;
        this.stopTimer();
        this.emitTimeUp();
        return;
      }

      this.minutes = Math.floor(remaining / 60);
      this.seconds = remaining % 60;
    },

    stopTimer() {
      clearInterval(this.timer);
      this.timer = null;
      this.startTime = null;
    },

    resetTimer() {
      this.stopTimer();
      this.minutes = this.initialMinutes;
      this.seconds = this.initialSeconds;
      this.resetAnimation();
    },

    // Handle visibility change to sync when tab becomes active again
    handleVisibilityChange() {
      if (!document.hidden && this.startTime) {
        // Tab became visible again, immediately update the timer
        this.updateTimer();
      }
    },

    startFlashing() {
      if (!this.$refs.timerText) return;
      gsap.to(this.$refs.timerText, {
        duration: 0.5,
        opacity: 0.5,
        repeat: -1,
        yoyo: true,
        ease: "power1.inOut",
      });
    },

    stopFlashing() {
      if (!this.$refs.timerText) return;
      gsap.killTweensOf(this.$refs.timerText);
      gsap.to(this.$refs.timerText, { opacity: 1, duration: 0.2 });
    },

    changeColor(color) {
      if (!this.$refs.timerText) return;
      gsap.to(this.$refs.timerText, { color, duration: 0.5 });
    },

    resetAnimation() {
      this.stopFlashing();
    },

    emitTimeUp() {
      this.$emit("time-up");
    },

    getRemainingSeconds() {
      return this.minutes * 60 + this.seconds;
    },

    restoreFromSeconds(totalSeconds) {
      if (!totalSeconds || isNaN(totalSeconds)) {
        console.warn('Invalid timer state provided');
        return;
      }
      
      // Set the timer values
      this.minutes = Math.floor(totalSeconds / 60);
      this.seconds = totalSeconds % 60;
      
      // Update the total duration to match the restored time
      this.totalDuration = totalSeconds;
      
      // Add this line to prevent startTimer() from resetting totalDuration
      this.startTime = 1; // Any non-null value will work
      
      // Reset animation state if needed
      this.resetAnimation();
    },
  },

  watch: {
    remainingTime(newRemainingTime) {
      if (newRemainingTime == 10) {
        this.startFlashing();
      } else if (newRemainingTime == 0) {
        this.resetAnimation();
      }
    },
  },

  mounted() {
    //this.startTimer(); // SDD: now start it manually
    // Listen for visibility changes
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },

  beforeUnmount() {
    this.stopTimer();
    this.resetAnimation();
    // Clean up event listener
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
};
</script>


<style scoped>
.countdown-timer {
  font-size: 1.2rem;
  color: #333;
  display: inline-flex;
  align-items: center;
}

.time-label {
  margin-right: 0.1rem;
}

.time-value {
  display: inline-block;
  min-width: 56px;
  text-align: right;
  font-variant-numeric: tabular-nums;
  font-feature-settings: "tnum";
}

h2 {
  font-size: 1.2rem;
}
</style>
